import React, { FC } from 'react';

import { useSelector } from 'react-redux';

import { VulnerabilitiesPrioritizationComponent } from 'containers/Dashboard/utils/VulnerabilitiesPrioritizationComponent';
import { selectVulnerabilities } from 'containers/Visibility/Vulnerabilities/selectors';

interface Props {
  setShow: (val: string) => void;
  activeStepIds?: string[];
  setActiveStepIds?: (value: string[]) => void;
}

export const VulnerabilitiesPrioritization: FC<Props> = props => {
  const { vulnerabilityPrioritization } = useSelector(selectVulnerabilities);
  const { useVulnerabilityV3 } = useSelector(selectVulnerabilities);

  return (
    <VulnerabilitiesPrioritizationComponent
      vulnerabilityPrioritization={vulnerabilityPrioritization.data}
      isLoading={vulnerabilityPrioritization.isLoading}
      showDropdown
      showHostTypeSummary={useVulnerabilityV3}
      {...props}
    />
  );
};
